<template>
    <div class="section5">
        <transition name="fade">
            <div class="swiper-area" v-if="firstin">
                <swiper :options="s5Options" @wheel.stop>
                    <swiper-slide :class="['slide', `slide${item.id}`]" v-for="(item, i) in jobs" :key="i">
                        <div class="left">
                            <div class="tit">
                                <img :src="require(`../../assets/${language}/5-1/5_1class.png`)" alt="">
                            </div>
                            <div class="job_info">
                                <div class="job_tit">
                                    <img class="job_name" :src="item.job" alt="">
                                    {{ i18n('job') }}：{{ item.name }}
                                </div>
                                <p :class="[language]">{{ item.intr }}</p>
                            </div>
                        </div>
                        <div 
                            class="right img pc"
                            :style="{ 'backgroundImage': `url(${require(`../../assets/zh/5-1/c${item.id}.png`)})` }"
                        >
                        </div>
                        <div 
                            class="right img wap"
                            :style="{ 'backgroundImage': `url(${require(`../../assets/wap/zh/5-1/c${item.id}.png`)})` }"
                        >
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-pagination s5-pagination"></div>
                <div class="swiper-button-prev s5_prev"></div>
                <div class="swiper-button-next s5_next"></div>
            </div>
        </transition>
    </div>
</template>
<script>
import i18n5 from './i18n5'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    components: {
        swiper,
        swiperSlide,
    },
    props: ['language','i18n'],
    computed: {
        jobs() {
            return [
                {
                    id: 1,
                    job: require(`../../assets/zh/5-1/name_c1.png`),
                    intr: i18n5(this.language).jobintr1,
                    name: i18n5(this.language).job1_name,
                },
                {
                    id: 2,
                    job: require(`../../assets/zh/5-1/name_c2.png`),
                    intr: i18n5(this.language).jobintr2,
                    name: i18n5(this.language).job2_name,
                },
                {
                    id: 3,
                    job: require(`../../assets/zh/5-1/name_c3.png`),
                    intr: i18n5(this.language).jobintr3,
                    name: i18n5(this.language).job3_name,
                },
                {
                    id: 4,
                    job: require(`../../assets/zh/5-1/name_c4.png`),
                    intr: i18n5(this.language).jobintr4,
                    name: i18n5(this.language).job4_name,
                },
                {
                    id: 5,
                    job: require(`../../assets/zh/5-1/name_c5.png`),
                    intr: i18n5(this.language).jobintr5,
                    name: i18n5(this.language).job5_name,
                },
                {
                    id: 6,
                    job: require(`../../assets/zh/5-1/name_c6.png`),
                    intr: i18n5(this.language).jobintr6,
                    name: i18n5(this.language).job6_name,
                }
            ]
        }
    },
    data() {
        return {
            firstin: false,
            s5Options: {
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true // 关键：让前一张淡出，后一张淡入
                },
                autoplay: {
                    delay: 3000,
                },
                pagination: {
                    el: '.s5-pagination',
                    clickable: true

                },
                navigation: {
                    nextEl: '.s5_next',
                    prevEl: '.s5_prev',
                },
            },
        }
    },
    methods: {
        onFirstVisit() {
            this.firstin = true
        }
    },

}
</script>
<style lang="less" scoped>
.section5 {
    overflow: hidden;
    width: 100%;
    height: 100%;
    background: url(../../assets/zh/5-1/5_1bg.png) center center / cover no-repeat;
    position: relative;

    .swiper-area {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;

        .swiper-container {
            width: 100%;
            height: 100%;
        }

        .slide {
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;

            .left {
                position: absolute;
                top: 2.05rem;
                left: 0;
                user-select: none;
                .tit {
                    width: 10.5rem;
                    height: 1.96rem;
                    background: url(../../assets/zh/5-1/tit_bg.png) 0 center / 10.93rem 100% no-repeat;
                    position: relative;
                    img {
                        height: .65rem;
                        width: auto;
                        position: absolute;
                        top: .8rem;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
                img {
                    display: block;
                }
                .job_info {
                    width: 9.17rem;
                    height: 4.86rem;
                    background: url(../../assets/zh/5-1/job_bg.png) 0 0 / 100% 100% no-repeat;
                    margin-left: .5rem;
                    padding: 1rem 1.4rem 0;
                    .job_tit {
                        display: flex;
                        align-items: center;
                        font-size: .36rem;
                        color: #723F31;
                        font-weight: 700;
                        margin-bottom: .2rem;
                        .job_name {
                            width: .68rem;
                            height: .68rem;
                            margin-right: .15rem;
                        }
                    }
                    p {
                        word-break: break-all;
                        color: #723F31;
                        font-size: .24rem;
                        line-height: 1.5;
                    }
                }
            }

            .img {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 12.11rem;
                height: 12rem;
                background-repeat: no-repeat;
                background-position: center bottom;
                &.pc {
                    display: block;
                }
                &.wap {
                    display: none;
                }
            }

            &.slide1 {
                .img {
                    background-size: 9.03rem 9.5rem;
                }
            }

            &.slide2 {
                .img {
                    background-size: 9.04rem 9.36rem;
                }
            }

            &.slide3 {
                .img {
                    background-size: 11.27rem 9.65rem;
                }
            }

            &.slide4 {
                .img {
                    background-size: 11.43rem 9.36rem;
                }
            }

            &.slide5 {
                .img {
                    background-size: 10.42rem 9.24rem;
                }
            }

            &.slide6 {
                .img {
                    background-size: 11.73rem 9.5rem;
                }
            }
        }

        ::v-deep .swiper-pagination {
            bottom: 1rem;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;

            .swiper-pagination-bullet {
                opacity: 1;
                width: 1.11rem;
                height: 1.11rem;
                margin: 0;
                background-position: center center;
                background-size: .68rem .68rem;
                background-repeat: no-repeat;
                background-color: transparent;
                position: relative;
                &::before {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                }
                &:nth-of-type(1) {
                    background-image: url(../../assets/zh/5-1/name_c1-1.png);
                    &.swiper-pagination-bullet-active {
                        background-image: url(../../assets/zh/5-1/name_c1.png);
                        &::before {
                            background: url(../../assets/zh/5-1/bullet1.png) 0 0 / 100% 100% no-repeat;
                        }
                    }
                }
                &:nth-of-type(2) {
                    background-image: url(../../assets/zh/5-1/name_c2-1.png);
                    &.swiper-pagination-bullet-active {
                        background-image: url(../../assets/zh/5-1/name_c2.png);
                        &::before {
                            background: url(../../assets/zh/5-1/bullet2.png) 0 0 / 100% 100% no-repeat;
                        }
                    }
                }
                &:nth-of-type(3) {
                    background-image: url(../../assets/zh/5-1/name_c3-1.png);
                    &.swiper-pagination-bullet-active {
                        background-image: url(../../assets/zh/5-1/name_c3.png);
                        &::before {
                            background: url(../../assets/zh/5-1/bullet3.png) 0 0 / 100% 100% no-repeat;
                        }
                    }
                }
                &:nth-of-type(4) {
                    background-image: url(../../assets/zh/5-1/name_c4-1.png);
                    &.swiper-pagination-bullet-active {
                        background-image: url(../../assets/zh/5-1/name_c4.png);
                        &::before {
                            background: url(../../assets/zh/5-1/bullet4.png) 0 0 / 100% 100% no-repeat;
                        }
                    }
                }
                &:nth-of-type(5) {
                    background-image: url(../../assets/zh/5-1/name_c5-1.png);
                    &.swiper-pagination-bullet-active {
                        background-image: url(../../assets/zh/5-1/name_c5.png);
                        &::before {
                            background: url(../../assets/zh/5-1/bullet5.png) 0 0 / 100% 100% no-repeat;
                        }
                    }
                }
                &:nth-of-type(6) {
                    background-image: url(../../assets/zh/5-1/name_c6-1.png);
                    &.swiper-pagination-bullet-active {
                        background-image: url(../../assets/zh/5-1/name_c6.png);
                        &::before {
                            background: url(../../assets/zh/5-1/bullet6.png) 0 0 / 100% 100% no-repeat;
                        }
                    }
                }
            }
        }

        .swiper-button-prev {
            outline: none;
            width: 1.88rem;
            height: 1.3rem;
            background: url(../../assets/zh/5-1/5_1left.png) 0 0 / 100% 100% no-repeat;
            left: unset;
            right: 10rem;
        }

        .swiper-button-next {
            outline: none;
            width: 1.88rem;
            height: 1.3rem;
            background: url(../../assets/zh/5-1/5_1right.png) 0 0 / 100% 100% no-repeat;
            right: .3rem;
        }
    }
}

@media screen and (max-width: 751px) {
    .section5 {
        background: url(../../assets/wap/zh/5-1/5_1bg.png) center center / cover no-repeat;
        .swiper-area {
            height: 100%;
            .swiper-container {

            }
            .slide {
                .left {
                    width: 100%;
                    left: 0;
                    height: 100%;
                    z-index: 2;
                    padding-top: 1.5rem;
                    top: 0;
                    .tit {
                        width: 7.4rem;
                        height: 1.27rem;
                        margin: 0 auto;
                        background: url(../../assets/wap/zh/5-1/tit_bg.png) 0 0 / 100% 100% no-repeat;
                        img {
                            height: .43rem;
                            top: .45rem;
                        }
                    }

                    .job_name {
                        margin: 0 0 .2rem;
                    }
                    .job_info {
                        position: absolute;
                        width: 7.51rem;
                        height: 3.4rem;
                        bottom: 1.63rem;
                        left: 50%;
                        transform: translateX(-50%);
                        padding: .6rem 1rem;
                        margin: 0;
                        background: url(../../assets/wap/zh/5-1/job_bg.png) 0 0 / 100% 100% no-repeat;
                        .job_tit {
                            margin-left: 0;
                            width: 100%;
                            height: .43rem;
                            justify-content: center;
                            img {
                                display: none;
                            }
                        }
                        p {
                            width: 100%;
                            margin-bottom: .1rem;
                            line-height: 1.2;
                            &.zh {
                                line-height: 1.5;
                            }
                        }
                    }
                }
                .img {
                    z-index: 1;
                    right: unset;
                    top: unset;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 0;
                    &.pc {
                        display: none;
                    }
                    &.wap {
                        display: block;
                    }
                }
                &.slide1 {
                    .img {
                        background-size: 7.06rem 10.53rem;
                    }
                }

                &.slide2 {
                    .img {
                        background-size: 8.01rem 10.5rem;
                    }
                }

                &.slide3 {
                    .img {
                        background-size: 8.68rem 10.53rem;
                    }
                }

                &.slide4 {
                    .img {
                        background-size: 10.71rem 10.19rem;
                    }
                }

                &.slide5 {
                    .img {
                        background-size: 8.59rem 10.31rem;
                    }
                }

                &.slide6 {
                    .img {
                        background-size: 10.15rem 10.36rem;
                    }
                }
            }
            ::v-deep .swiper-pagination {
                bottom: .75rem;
            }
            .swiper-button-prev {
                left: 0.3rem;
                right: unset;
                -webkit-tap-highlight-color: transparent;
            }
            .swiper-button-next {
                -webkit-tap-highlight-color: transparent;
            }
        }
    }
}
</style>